module.exports = __webpack_public_path__ + "img/win_safe.78cc1895.png";